import { createContext } from '@lit/context';
import { SiteAccessibility } from '../types';

export const sitesDataContext = createContext<SiteAccessibility[]>('sitesData');
